import {Routes} from '@angular/router';
import {PublicComponent} from './public/public.component';
import {PublicfaqComponent} from './public/publicfaq/publicfaq.component';
import {AdminComponent} from './admin/admin.component';
import {AdminIndexComponent} from './admin/admin-index/admin-index.component';
import {LabelComponent} from './admin/label/label.component';
import {InfosComponent} from './admin/infos/infos.component';
import {FaqCategoriesComponent} from './admin/faq-categories/faq-categories.component';
import {InfosArchiveComponent} from './admin/infos-archive/infos-archive.component';
import {ToolsComponent as AdminToolsComponent} from './admin/tools/tools.component';
import {AuthGuard} from './auth.guard';
import {UserComponent} from './user/user.component';
import {DashboardComponent} from './user/dashboard/dashboard.component';
import {InformationsComponent} from './user/informations/informations.component';
import {TicketsComponent} from './user/tickets/tickets.component';
import {TicketDetailComponent} from './user/tickets/ticket-detail/ticket-detail.component';
import {ToolsComponent} from './user/tools/tools.component';
import {FaqComponent} from './user/faq/faq.component';
import {FaqArticleComponent} from './user/faq/faq-article/faq-article.component';
import {MeetingsComponent} from './user/meetings/meetings.component';
import {UsersComponent} from './user/portal-users/users/users.component';
import {UsersCreateComponent} from './user/portal-users/users-create/users-create.component';
import {Error503Component} from './error/error503/error503.component';
import {UsersHistoryComponent} from './user/portal-users/users-history/users-history.component';
import {TicketCreateComponent} from './user/tickets/ticket-create/ticket-create.component';
import {ResourcesComponent} from './user/resources/resources.component';
import {AccountComponent} from './user/account/account.component';
import {RgpdComponent} from './user/rgpd/rgpd.component';
import {HealthComponent} from './public/health/health.component';
import {HelpComponent} from './user/help/help.component';
import {NoAccessComponent} from './user/no-access/no-access.component';
import {UserListComponent} from './admin/user-list/user-list.component';
import {ContractsComponent} from './user/portal-users/contracts/contracts.component';
import {EventsComponent} from "./admin/events/events.component";
import {UserEditRequestComponent} from "./admin/user-edit-request/user-edit-request.component";
import {UserAddRequestComponent} from "./admin/user-add-request/user-add-request.component";
import {SitemapComponent} from "./user/sitemap/sitemap.component";
import {ReleaseNotesComponent} from "./user/release-notes/release-notes.component";
import {MaintenanceComponent} from './maintenance/maintenance.component';

export const routes: Routes = [
  {
    path: 'erreur',
    component: PublicComponent,
    children: [
      {path: '503', component: Error503Component}
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'maintenance',
    component: PublicComponent,
    children: [
      {path: '', component: MaintenanceComponent}
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {path: 'health', component: HealthComponent},
      {path: ':id', component: PublicfaqComponent}
    ],
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      {path: '', component: AdminIndexComponent},
      {path: 'label', redirectTo: 'labels', pathMatch: 'full'},
      {path: 'labels', component: LabelComponent},
      {path: 'infos', redirectTo: 'informations', pathMatch: 'full'},
      {path: 'informations', component: InfosComponent},
      {path: 'faq', component: FaqCategoriesComponent},
      {path: 'archive', redirectTo: 'archives', pathMatch: 'full'},
      {path: 'archives', component: InfosArchiveComponent},
      {path: 'tools', redirectTo: 'outils', pathMatch: 'full'},
      {path: 'outils', component: AdminToolsComponent},
      {path: 'user-requests', redirectTo: 'demandes', pathMatch: 'full'},
      {path: 'demandes', component: UserAddRequestComponent},
      {path: 'modifications', component: UserEditRequestComponent},
      {path: 'user-list', redirectTo: 'utilisateurs', pathMatch: 'full'},
      {path: 'utilisateurs', component: UserListComponent},
      {path: 'evenements', component: EventsComponent},
    ],
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: UserComponent,
    children: [
      {path: '', component: DashboardComponent},
      {path: 'no-access', component: NoAccessComponent},
      {path: 'infos', redirectTo: 'informations', pathMatch: 'full'},
      {path: 'informations', component: InformationsComponent},
      {path: 'tickets', component: TicketsComponent},
      {path: 'tickets/new', redirectTo: 'tickets/nouveau', pathMatch: 'full'},
      {path: 'tickets/nouveau', component: TicketCreateComponent},
      {path: 'tickets/:id', component: TicketDetailComponent},
      {path: 'tools', redirectTo: 'outils', pathMatch: 'full'},
      {path: 'outils', component: ToolsComponent},
      {path: 'faq', component: FaqComponent},
      {path: 'faq/:id', component: FaqArticleComponent},
      {path: 'resources', redirectTo: 'documentations', pathMatch: 'full'},
      {path: 'documentations', component: ResourcesComponent},
      {path: 'documentations/:id', component: ResourcesComponent},
      {path: 'meetings', redirectTo: 'prestations', pathMatch: 'full'},
      {path: 'prestations', component: MeetingsComponent},
      {path: 'account', redirectTo: 'compte', pathMatch: 'full'},
      {path: 'compte', component: AccountComponent},
      {path: 'users', redirectTo: 'utilisateurs', pathMatch: 'full'},
      {path: 'utilisateurs', component: UsersComponent},
      {path: 'rgpd', component: RgpdComponent},
      {path: 'help', redirectTo: 'aide', pathMatch: 'full'},
      {path: 'aide', component: HelpComponent},
      {path: 'users/create', redirectTo: 'utilisateurs/nouveau', pathMatch: 'full'},
      {path: 'utilisateurs/nouveau', component: UsersCreateComponent},
      {path: 'users/history', redirectTo: 'utilisateurs/historique', pathMatch: 'full'},
      {path: 'utilisateurs/historique', component: UsersHistoryComponent},
      {path: 'contrats', component: ContractsComponent},
      {path: 'plan-du-site', component: SitemapComponent},
      {path: 'notes-de-version/:slug', component: ReleaseNotesComponent},
      {path: 'notes-de-version/:slug/:version', component: ReleaseNotesComponent},
    ],
    canActivate: [AuthGuard],
  },
  {path: '**', redirectTo: ''}
];
